import { render, staticRenderFns } from "./AppointmentHistory.vue?vue&type=template&id=c13c4c0e&scoped=true"
import script from "./AppointmentHistory.vue?vue&type=script&lang=js"
export * from "./AppointmentHistory.vue?vue&type=script&lang=js"
import style0 from "./AppointmentHistory.vue?vue&type=style&index=0&id=c13c4c0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13c4c0e",
  null
  
)

export default component.exports